import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["render", "children"];
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useModalControl } from "../../hooks/useModalControl";

/** Controls toggling the visible status of a modal,
 * and handles the accessibility concern of returning focus
 * to the toggle button when the modal closes. */
import { jsx as ___EmotionJSX } from "@emotion/core";
function ModalControl(_ref) {
  let {
      render,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const controlProps = useModalControl(props);
  return ___EmotionJSX(React.Fragment, null, (render || children)(controlProps));
}
ModalControl.propTypes = {
  /** `function` as children. Used to render both the trigger button and the `Modal`. */
  children: PropTypes.func,
  /** Optional prop to delay returning focus for a specified duration (in ms). */
  focusDelay: PropTypes.number,
  /** Render prop. Used to render both the trigger button and the `Modal`. */
  render: PropTypes.func
};
ModalControl.defaultProps = {
  focusDelay: 0
};
export { ModalControl };